import { createAction } from 'redux-act';

import { Reservation } from '../../../models/interfaces/reservation/Reservation';
import TimestampPayload from '../TimestampPayload';
import ReservationPayload from './ReservationPayload';

export interface RejectReservationPayload extends ReservationPayload {
  reservation: Reservation;
}
export const rejectReservation = createAction<RejectReservationPayload>('REJECT_RESERVATION');

export interface ReservationRejectedPayload extends TimestampPayload, ReservationPayload {
  reservation: Reservation;
}
export const reservationRejected = createAction<ReservationRejectedPayload>('RESERVATION_REJECTED');

export type ReservationRejectFailedPayload = TimestampPayload & ReservationPayload;
export const reservationRejectFailed = createAction<ReservationRejectFailedPayload>('RESERVATION_REJECT_FAILED');
